import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class AirconhistorystatusService {
  getallAirconhistorystatus(data) {
    return axios.get(serverURL + "/airconhistorystatus-api?req=smarttableAirconhistorystatus", {
      params: data,
      headers: headeroption,
    })
  }
  getAirconhistorystatus(status_id) {
    return axios.get(serverURL + "/airconhistorystatus-api?req=getAirconhistorystatus", {
      params: { status_id: status_id }, headers: headeroption,
    });
  }
  createAirconhistorystatus(data) {
    return axios.post(serverURL + "/airconhistorystatus-api?req=createAirconhistorystatus", data, {
      headers: headeroption,
    });
  }
  updateAirconhistorystatus(data) {
    return axios.put(serverURL + "/airconhistorystatus-api?req=updateAirconhistorystatus", data, {
      headers: headeroption,
    });
  }
  deleteAirconhistorystatus(status_id) {
    return axios.delete(serverURL + "/airconhistorystatus-api?req=deleteAirconhistorystatus", { params: { status_id: status_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/airconhistorystatus-api?req=deleteAirconhistorystatus");
  }
  findByTitle(status_name) {
    return axios.get(serverURL + "/airconhistorystatus/airconhistorystatus-api?name=" + status_name);
  }
  upload(status_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?status_id=" + status_id, data, { headers: headeroptionupload });
  }
  uploads(status_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?status_id=" + status_id, data, { headers: headeroptionupload });
  }
}
export default new AirconhistorystatusService();
